import { Link } from "react-router-dom";
import { CabecalhoPublico } from "../componentes/Marca.js";
import { RodapeLegal } from "../componentes/Legal.js";
import { MetadadosPagina } from "../componentes/Metadados.js";
import { Botao } from "../componentes/ui.js";
import { abrirPreferenciasMedicao } from "../telemetria.js";
import "./landing.css";

/**
 * Termos e privacidade em texto simples, sem juridiques desnecessario.
 * Rascunho para revisao profissional; o conteudo reflete o que o sistema
 * FAZ, e nada alem — prometer menos do que se faz e tao errado quanto o
 * contrario.
 */
export function Termos() {
  return (
    <>
      <MetadadosPagina caminho="/termos" />
      <CabecalhoPublico acao={<Link to="/" className="botao botao--texto">Início</Link>} />
      <main className="lp">
        <section>
          <div className="lp__interno pilha pilha-5" style={{ maxWidth: 720 }}>
            <div className="pilha pilha-2">
              <span className="rotulo">Vigente desde 04/09/2026</span>
              <h1>Termos de uso</h1>
            </div>

            <div className="pilha pilha-4 lp__texto-legal">
              <h2>1. O que o serviço é</h2>
              <p>
                O alugando.com, operado por CNPJ 40.838.857/0001-08, com sede
                na Rua Parnaíba, 585, Minaslândia, Belo Horizonte/MG, CEP
                31812-280 ("nós"), é uma ferramenta de cálculo e organização do
                carnê-leão de aluguéis recebidos de pessoas físicas. Calculamos
                o imposto a partir do que você informa, emitimos o DARF pelo
                Sicalc da Receita Federal, guardamos seus comprovantes e geramos
                o arquivo anual de escrituração.
              </p>
              <p>
                O escopo é o IRPF recolhido via carnê-leão, e só ele. Ficam fora:
                a retenção na fonte devida por locatário pessoa jurídica (feita
                pela própria empresa) e os tributos IBS/CBS da reforma
                tributária, que a partir de 2027 podem alcançar alguns
                locadores. Se uma dessas regras alcançar seu caso, avisamos, mas
                o serviço não as apura.
              </p>

              <h2>2. O que o serviço não é</h2>
              <p>
                Não somos escritório de contabilidade nem prestamos consultoria
                tributária. Não acessamos sua conta na Receita: sem procuração,
                sem senha do gov.br. A responsabilidade pelo tributo e pela
                declaração é sua, como contribuinte; você confirma cada valor
                antes de qualquer emissão, e o texto confirmado fica registrado.
              </p>
              <p>
                A cobrança do inquilino pelo serviço consiste no envio dos
                lembretes configurados pelo usuário. Havendo inadimplência, as
                cobranças e providências cabem ao locador ou à imobiliária.
              </p>

              <h2>3. Cálculo e emissão</h2>
              <p>
                O cálculo segue as regras vigentes e é conferido contra o
                demonstrativo oficial do Carnê-Leão Web. A guia (DARF) é emitida
                pelo Sicalc, via Serpro, com multa e juros consolidados pela
                própria Receita quando houver atraso. O documento oficial é o
                DARF emitido; nossos números anteriores à emissão são
                estimativa.
              </p>

              <h2>4. Pagamento do imposto por Pix (mandato)</h2>
              <p>
                Se você optar por pagar por Pix, você nos autoriza a receber o
                valor exato do seu DARF em nossa conta, exclusivamente para
                quitá-lo na Receita Federal em seu CPF, de forma automática. A
                autorização é individual: cada código Pix é gerado a seu pedido,
                para uma guia específica, e não cobramos nenhuma tarifa pela
                operação, que está incluída na assinatura. O
                valor recebido não é receita nossa: é repasse, mantido em conta
                dedicada exclusivamente a essas operações, da qual tudo que
                entra sai para a Receita ou volta para você. Se o DARF não for
                pago por qualquer motivo, devolvemos o valor integralmente pela
                devolução do próprio Pix, à conta de origem. Nunca pagamos o
                DARF antes de o seu Pix estar confirmado, e nunca usamos o valor
                para outra finalidade.
              </p>

              <h2>5. Assinatura e cancelamento</h2>
              <p>
                O preço depende da soma bruta mensal dos aluguéis dos
                contratos cadastrados: R$ 34,90 por mês para soma abaixo de
                R$ 5.000; de R$ 5.000 a R$ 49.999, faixas de R$ 5.000 em
                R$ 5.000 valendo 1% do piso da faixa (R$ 50, R$ 100, R$ 150,
                até R$ 450); a partir de R$ 50.000, 2% da soma dos contratos.
                O valor é sempre exibido antes da contratação. O
                primeiro mês é grátis, sem fidelidade. Entrar e iniciar o
                cadastro não consome esse período: os 30 dias começam
                automaticamente somente quando você conclui o onboarding. Se a soma dos contratos
                mudar de faixa, a mensalidade é reenquadrada a partir da
                cobrança seguinte, com aviso por email e WhatsApp; cobrança já
                emitida não muda de valor. A cobrança é processada pelo Asaas. Você pode
                cancelar a qualquer momento no painel; o período já pago
                continua valendo até o fim. A emissão de guias exige assinatura
                ativa. O arquivo anual de escrituração é entregue em janeiro a
                quem manteve a assinatura até dezembro do ano-base, mesmo que
                cancele depois: quem pagou o ano tem o ano. Seus lançamentos e
                comprovantes permanecem guardados e acessíveis.
              </p>

              <h2>6. Direito de arrependimento</h2>
              <p>
                Como a contratação é feita pela internet, você pode desistir em
                até 7 dias corridos após o primeiro pagamento, com devolução
                integral do valor (CDC, art. 49). Basta pedir pelo painel ou
                pelo email de suporte. Como o primeiro mês é grátis, o prazo
                conta do primeiro pagamento efetivo, não do cadastro.
              </p>

              <h2>7. Suas obrigações</h2>
              <p>
                Informar valores verdadeiros e completos, conferir cada
                confirmação antes de aceitar, e manter seus dados de contato
                atualizados. O cálculo certo sobre informação errada produz
                imposto errado, e a responsabilidade pela informação é sua.
              </p>

              <h2>8. Responsabilidade</h2>
              <p>
                Respondemos pelos danos que um defeito do nosso serviço causar a
                você, na forma do Código de Defesa do Consumidor. Em especial,
                se um erro de cálculo nosso sobre informação correta que você
                forneceu gerar multa e juros, esses acréscimos são problema
                nosso, não seu. Não respondemos por informação incorreta ou
                incompleta fornecida por você, nem por indisponibilidade de
                sistemas de terceiros (Receita, Serpro, bancos) que não decorra
                de falha nossa. A responsabilidade pelo tributo em si é sempre
                do contribuinte: o imposto devido seria devido com ou sem a
                gente.
              </p>

              <h2>9. Encerramento</h2>
              <p>
                Você pode encerrar sua conta quando quiser, levando seus dados:
                o arquivo de escrituração e o relatório anual são exportáveis.
                Podemos encerrar o serviço com aviso de 30 dias, mantendo seu
                acesso aos dados até lá.
              </p>

              <h2>10. Foro</h2>
              <p>
                Estes termos seguem a lei brasileira. Fica eleito o foro da
                comarca de Belo Horizonte/MG, salvo competência legal diversa do
                seu domicílio como consumidor.
              </p>

              <p className="tenue">
                Dúvidas: suporte@alugando.com. Veja também a{" "}
                <Link to="/privacidade">política de privacidade</Link>.
              </p>
            </div>
          </div>
        </section>
        <footer className="lp__rodape"><RodapeLegal /></footer>
      </main>
    </>
  );
}

export function Privacidade() {
  return (
    <>
      <MetadadosPagina caminho="/privacidade" />
      <CabecalhoPublico acao={<Link to="/" className="botao botao--texto">Início</Link>} />
      <main className="lp">
        <section>
          <div className="lp__interno pilha pilha-5" style={{ maxWidth: 720 }}>
            <div className="pilha pilha-2">
              <span className="rotulo">Vigente desde 03/09/2026</span>
              <h1>Política de privacidade</h1>
            </div>

            <div className="pilha pilha-4 lp__texto-legal">
              <h2>1. Quem somos</h2>
              <p>
                O alugando.com, operado por CNPJ 40.838.857/0001-08, com sede
                na Rua Parnaíba, 585, Minaslândia, Belo Horizonte/MG, CEP
                31812-280, é o controlador dos dados tratados pelo serviço.
                Contato: suporte@alugando.com.
              </p>

              <h2>2. O que coletamos e por quê</h2>
              <p>
                <strong>Seus dados</strong>: nome, email, CPF, telefone e dados
                fiscais (aluguéis, dependentes, imóveis): necessários para
                calcular o imposto e emitir o DARF em seu nome.{" "}
                <strong>Dados dos seus inquilinos</strong>: nome e CPF,
                exigidos pela Receita na escrituração e na sua declaração, e,
                quando você ativa os lembretes, email e telefone para realizar
                essa comunicação e receber comprovantes. A obrigação fiscal é
                sua: para esses dados, você atua como controlador e nós como
                operadores, tratando-os apenas sob suas instruções e para essas
                finalidades.{" "}
                <strong>Comprovantes</strong>: os arquivos que você encaminha,
                para organizar seus meses e provar seus registros.
              </p>
              <p>
                <strong>WhatsApp do inquilino</strong>: ao ativar os lembretes,
                você declara que o contato informado pertence ao inquilino do
                contrato vigente. Na primeira mensagem, a Bia se identifica,
                explica a finalidade do canal e informa que o destinatário pode
                deixar de receber lembretes a qualquer momento, bastando
                comunicar isso na conversa. O inquilino pode encaminhar o
                comprovante final de pagamento pelo canal; agendamento ou
                operação ainda em processamento não é tratado como comprovante
                de pagamento.
              </p>
              <p>
                <strong>Cadastro e aquisição</strong>: ao entrar com Google,
                guardamos UID, nome e email para criar e proteger sua conta.
                No primeiro acesso, registramos que o endereço entrou no
                serviço e avisamos nossa administração por email. Também
                guardamos a atribuição de primeiro acesso (UTMs, domínio de
                referência, página e data) para entender a aquisição. Registros
                da antiga lista de espera permanecem apenas como histórico.
              </p>
              <p>
                <strong>WhatsApp</strong>: o telefone é opcional. Ao informá-lo
                no cadastro, você autoriza uma mensagem inicial e os avisos
                necessários ao serviço. As mensagens e os arquivos que você
                enviar são usados para atender ao pedido, ler contratos e
                organizar comprovantes. Responda “sair” a qualquer momento
                para impedir novas mensagens iniciadas por nós; se você nos
                escrever depois, responderemos somente ao novo pedido.
              </p>
              <p>
                <strong>Métricas e replay</strong>: usamos PostHog para medir
                o funil e localizar problemas de uso. Inputs, texto de páginas
                privadas, conversas, documentos, imagens enviadas, atributos
                potencialmente pessoais e dados de rede são mascarados ou bloqueados antes do envio; IP
                não é armazenado. Eventos usam apenas o UID e propriedades sem
                nome, email, CPF, telefone ou conteúdo fiscal.
              </p>
              <p>
                <strong>Medição de anúncios</strong>: usamos o Pixel e a API
                de Conversões da Meta, o Google Analytics e a tag do Google
                Ads para relacionar
                anúncios a visitas, leads, cadastros, início de teste e
                assinatura e mostrar anúncios do Alugando novamente a quem visitou
                o site ou interagiu com o serviço. Meta e Google recebem somente o nome do marco,
                horário, página de entrada e identificadores técnicos do
                navegador ou do clique no anúncio. Quando necessário para
                deduplicar uma assinatura, usamos um identificador interno
                transformado em hash. Não enviamos
                nome, email, telefone, CPF, valor de aluguel, valor de
                imposto, documentos ou conteúdo do produto. Essa medição fica
                ativa por padrão com fundamento em nosso legítimo interesse
                de medir a aquisição do serviço e divulgar o Alugando. Você pode desativá-la quando
                quiser, sem perder nenhuma função.
                Os scripts são carregados dos domínios da Meta e do Google,
                que podem observar o endereço IP e dados básicos do navegador
                nessas conexões; nossa API de Conversões não inclui o endereço IP.
              </p>
              <p>
                <Botao variante="secundario" onClick={abrirPreferenciasMedicao}>
                  Alterar medição de anúncios
                </Botao>
              </p>
              <p>
                <strong>Atendimento</strong>: guardamos as solicitações e
                respostas do widget de suporte. Para preparar um rascunho para
                nossa equipe, um agente da OpenAI pode consultar um retrato
                reduzido da sua conta, como estado do acesso, assinatura,
                imóveis, competências, pagamentos e atividades relevantes.
                CPF, documentos, credenciais, códigos de pagamento e dados
                bancários não são enviados ao agente. O rascunho não é enviado
                automaticamente: uma pessoa da nossa equipe precisa revisar e
                confirmar cada resposta.
              </p>

              <h2>3. Como guardamos</h2>
              <p>
                Comprovantes e documentos são cifrados por nós antes de gravados
                (AES-256, chave fora do armazenamento), além da criptografia
                padrão da infraestrutura. O acesso aos arquivos expira em 24
                horas por link. Registramos um histórico imutável de eventos
                (quem confirmou o quê, quando) porque ele é a sua proteção
                jurídica e a nossa.
              </p>

              <h2>4. Com quem compartilhamos</h2>
              <p>
                Somente operadores necessários ao serviço: Google (Firebase,
                infraestrutura e armazenamento), Serpro (emissão do DARF, órgão
                público), OpenAI (interpretação das mensagens e leitura de
                comprovantes), Asaas (cobrança da assinatura), Banco Inter
                (recebimento do Pix e pagamento do DARF), Banger e Resend
                (email), PostHog (métricas protegidas e replay mascarado), Google
                (Firebase, Analytics e Ads) e Meta
                (WhatsApp, quando você usa o canal, e medição de anúncios
                enquanto essa preferência estiver ativa). Google, OpenAI, Resend,
                PostHog e Meta
                processam dados em servidores fora do Brasil (Estados Unidos);
                essas transferências se amparam nas cláusulas contratuais e
                garantias de proteção desses fornecedores, nos termos da
                regulamentação da ANPD. Não vendemos nem cedemos dados a
                terceiros para publicidade.
              </p>

              <h2>5. Seus direitos</h2>
              <p>
                Nos termos da LGPD (Lei 13.709/2018): confirmar o tratamento,
                acessar, corrigir, portar (o arquivo de escrituração é seu) e
                eliminar dados. A retenção varia por categoria: documentos e
                registros fiscais ficam 5 anos (prazo decadencial tributário,
                porque são a sua defesa em fiscalização), dados cadastrais
                ficam enquanto a conta existir, e conversas ficam enquanto
                servirem à sua escrituração, elimináveis a pedido. Dados da
                antiga lista de espera são removidos quando a conta é encerrada
                ou a pessoa pede exclusão. Encarregado
                pelo tratamento (LGPD, art. 41): Tiago Silva Loureiro,
                suporte@alugando.com.
              </p>

              <h2>6. Incidentes</h2>
              <p>
                Em caso de incidente de segurança com risco a você, comunicamos
                você e a ANPD nos prazos da lei, com o que aconteceu, o que foi
                afetado e o que fizemos.
              </p>

              <p className="tenue">
                Veja também os <Link to="/termos">termos de uso</Link>.
              </p>
            </div>
          </div>
        </section>
        <footer className="lp__rodape"><RodapeLegal /></footer>
      </main>
    </>
  );
}
